export default __webpack_public_path__ + "static/media/garanti-pay.a6bfbeda.png";